import { render, staticRenderFns } from "./AcademicYearSelectCpt.vue?vue&type=template&id=97a12dde&scoped=true&"
import script from "./AcademicYearSelectCpt.vue?vue&type=script&lang=ts&"
export * from "./AcademicYearSelectCpt.vue?vue&type=script&lang=ts&"
import style0 from "./AcademicYearSelectCpt.vue?vue&type=style&index=0&id=97a12dde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a12dde",
  null
  
)

export default component.exports